var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-container"},[(_vm.isAuthenticated)?_c('Sidebar',{attrs:{"navItems":_vm.filteredItems}}):_vm._e(),_c('MainLayout',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }